import { $FIXME } from '../../constants';

const scrollToRef = (ref: $FIXME) => window.scrollTo(0, ref.current.offsetTop);
export default scrollToRef;
